import { useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { createElement } from 'react';
import '../../utilities/get-styleprop.js';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import Chip from '../../Chip/Chip.js';

const SummarySectionChip = ({
  content,
  onRemove
}) => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Chip, {
    renderContent: () => content,
    styles: {
      wrapper: {
        mr: `${theme.spacing.xs}px`
      }
    },
    onRemove: onRemove
  });
};

export default SummarySectionChip;
